const adjustSectionsStackOrder = () => {
  document.querySelectorAll('.content-for-layout .shopify-section')
    .forEach((section, index) => {
      if (section.classList.contains('section--anchor-target')) {
        return null
      }

      Object.assign(section.style, {
        display: 'block',
        position: section.style.position === 'sticky' ? 'sticky' : 'relative',
        zIndex: index + 1,
        backgroundColor: !section.style.backgroundColor ? '#FFF' : section.style.backgroundColor,
      })
    })
}
class SectionScrollInOver extends HTMLElement {
  constructor() {
    super()

    this.parentSection = this.closest('.shopify-section')
    this.previousSection = this.findPreviousSection()
  }

  connectedCallback() {
    if (
      !this.parentSection ||
      !this.previousSection ||
      !this.previousSection?.classList?.contains('shopify-section')
    ) {
      return null
    }

    this.adjustSectionStyles()
    window.addEventListener('resize', this.adjustSectionStyles.bind(this))
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.adjustSectionStyles.bind(this))
  }

  previousSectionTop() {
    const prevSectionHeight = this.previousSection.scrollHeight
    const adjustmentAmount = prevSectionHeight - window.innerHeight * 0.5
    return adjustmentAmount * -1
  }

  adjustSectionStyles() {
    Object.assign(this.parentSection.style, {
      position: 'relative',
      display: 'block',
    })

    Object.assign(this.previousSection.style, {
      position: 'sticky',
      display: 'block',
      top: `${this.previousSectionTop()}px` ,
    })

    adjustSectionsStackOrder()
  }

  findPreviousSection() {
    let previousSection = this.parentSection?.previousElementSibling
    while (previousSection !== null) {
      if (
        previousSection !== null &&
        !previousSection.classList.contains('anchor_target_id')
      ) { return previousSection }
      previousSection = previousSection.previousElementSibling;
    }
    return null
  }
}

customElements.define('section-scroll-in-over', SectionScrollInOver)

// Ensure stacking works after section is editied in the admin
document.addEventListener('shopify:section:load', () => {
  adjustSectionsStackOrder()
})
